import { PublicClientApplication } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        //BY ENV
        clientId: process.env.VUE_APP_ROOT_CLIENTID,
        authority: process.env.VUE_APP_ROOT_AUTHORITY,
        //local testing
        //clientId: '7a984324-869e-4816-93b1-217b7efdf7f5',
        //authority: 'https://login.microsoftonline.com/8b6f9a60-42ef-4a4c-b3c5-7fb4d0c3f214'

        //Staging(UAT)
        //clientId: 'd2c391de-ae4e-4f10-8861-45a890a748a6',
        //authority: 'https://login.microsoftonline.com/cd99fef8-1cd3-4a2a-9bdf-15531181d65e'
    },
    cache: {
        cacheLocation: "localStorage", // 'sessionStorage'
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                // switch (level) {
                //     case LogLevel.Error:
                //         console.error(message);
                //         return;
                //     case LogLevel.Info:
                //         console.info(message);
                //         return;
                //     case LogLevel.Verbose:
                //         console.debug(message);
                //         return;
                //     case LogLevel.Warning:
                //         console.warn(message);
                //         return;
                //     default:
                //         return;
                // }
            },
            logLevel: '',
        },
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: [],
};

// Add here the endpoints for MS Graph API services you would like to use.
//export const graphConfig = {
//   /* graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',*/
//};
